import { apiFetch } from '../client';
import { formattedPhoneNumber } from "../../components/login/helpers";

export function userExists(value) {
    return apiFetch(`/user-api/exists/?${value}`, {
        method: 'GET'
    })
}

export function loginOrRegister(data) {
    let payload = {...data}
    if(payload.mobile_phone_number) {
        payload.mobile_phone_number = formattedPhoneNumber(payload.mobile_phone_number)
    }
    return apiFetch('/user-api/login/', {
        method: 'POST',
        body: JSON.stringify({ data: payload })
    })
}

export function verifyCode(code, userID, email) {
    const url = `/verifycode/${code}${userID ? userID : ''}/?json=true${(email && !userID) ? '&email=' + encodeURIComponent(email) : ''}`
    return apiFetch(url, {
        method: 'GET'
    })
}

export function handleBankID(email, sessionID) {
    let url = "/user-api/bankidlogin/?email=" + encodeURIComponent(email) 
    sessionID ? url += "&sessionid=" + encodeURIComponent(sessionID) : url
    return apiFetch(url, { method: 'GET' })
}

